import axios from 'axios';
import get from 'lodash/get';
import identityConfig from '../../../config/identity';
import log from '../../../services/logger_service';

export default function loadComscoreTracker(currentState) {
  let site = get(currentState, 'context.site', 'fastcompany');
  const comscoreConfig = get(identityConfig, 'comscore');
  const { c1, c2 } = comscoreConfig;
  if (site) {
    site = site.toUpperCase();
  } else {
    site = window.location.hostname;
  }
  // reset COMSCORE
  if (window.COMSCORE && window.COMSCORE.beacon) {
    window.COMSCORE.beacon({
      c1,
      c2,
      options: {
        url_append: `comscorekw=${site}`
      }
    });
    axios
      .get('https://services.fastcompany.com/v1/comscore_ping')
      .catch(error => {
        log.error(error, 'Comscore page view candidate failed');
      });
  }
}

export function sendComscoreCandidatePing() {
  // figure out domain site name and deal with subdomains etc
  const hostNameSplit = window.location.hostname.split('.');
  let site =
    get(hostNameSplit, 'length') === 2 ? hostNameSplit[0] : hostNameSplit[1];

  const comscoreConfig = get(identityConfig[site], 'comscore', {});
  const { c1, c2 } = comscoreConfig;

  if (site) {
    site = site.toUpperCase();
  }
  // reset COMSCORE
  if (window.COMSCORE && window.COMSCORE.beacon) {
    window.COMSCORE.beacon({
      c1,
      c2,
      options: {
        url_append: `comscorekw=${site}`
      }
    });
    axios
      .get('https://services.fastcompany.com/v1/comscore_ping')
      .catch(error => {
        log.error(error, 'Comscore page view candidate failed');
      });
  }
}
